import {
  SET_CART,
  SET_CART_LOADING,
  UNSET_CART_LOADING,
  IS_CART_SAVED,
} from '@/cart/context/types';

export const setCart = payload => ({ type: SET_CART, payload });
export const setCartLoading = () => ({ type: SET_CART_LOADING });
export const unsetCartLoading = () => ({ type: UNSET_CART_LOADING });
export const setIsCartSaved = () => ({ type: IS_CART_SAVED });
